(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

  // Progressive styling only: Shopify retains ownership of form loading and submission.
  if (!customElements.get('hno-footer-forms')) {
    customElements.define('hno-footer-forms', class extends HTMLElement {
      connectedCallback() {
        this.applyFormStyle = () => {
          const container = this.querySelector('[data-forms-id="forms-root-1181928"]');
          if (!container) return;
          const host = container.matches('form-embed') ? container : container.querySelector('form-embed');
          const root = host && host.shadowRoot;
          if (!root) return;
          const existing = root.querySelector('style[data-hno-footer-style]');
          if (existing) return;
          const style = document.createElement('style');
          style.dataset.hnoFooterStyle = '1181928';
          style.textContent = "\n:host {\n  color-scheme: dark;\n  --forms-text-color: #f7f4ed;\n  --forms-background-color: #050505;\n  --forms-button-background-color: #c6a15b;\n  --forms-button-label-color: #080705;\n}\n:host form {\n  width: 100% !important;\n  max-width: 560px !important;\n  margin: 0 auto !important;\n  background: transparent !important;\n  gap: 10px !important;\n}\n:host :is(h1,h2,h3) {\n  margin: 0 0 7px !important;\n  padding: .03em .12em .1em !important;\n  background: linear-gradient(105deg,#765015 0%,#c6a15b 18%,#fff0a8 34%,#b98228 48%,#fff6c9 63%,#c6a15b 80%,#765015 100%) !important;\n  background-size: 260% auto !important;\n  background-clip: text !important;\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n  color: #c6a15b !important;\n  font-size: clamp(18px, 2vw, 26px) !important;\n  font-weight: 900 !important;\n  letter-spacing: -.02em !important;\n  line-height: 1.15 !important;\n  text-transform: uppercase !important;\n  animation: hno-form-shine 6s linear infinite;\n}\n:host p {\n  font-size: 13px !important;\n  line-height: 1.45 !important;\n}\n:host :is(input:not([type=\"hidden\"]):not([type=\"checkbox\"]):not([type=\"radio\"]),select,textarea) {\n  box-sizing: border-box !important;\n  min-width: 0 !important;\n  min-height: 44px !important;\n  border: 1px solid rgba(198,161,91,.68) !important;\n  border-radius: 0 !important;\n  background: #050505 !important;\n  color: #f7f4ed !important;\n  box-shadow: inset 0 0 0 1px rgba(198,161,91,.08) !important;\n  font-size: 16px !important;\n  caret-color: #fff0a8;\n}\n:host :is(div,fieldset):has(> input:not([type=\"hidden\"]):not([type=\"checkbox\"]):not([type=\"radio\"])) {\n  background: #050505 !important;\n  border-radius: 0 !important;\n}\n:host input::placeholder,\n:host textarea::placeholder {\n  color: rgba(247,244,237,.65) !important;\n  opacity: 1;\n}\n:host label {\n  color: #f7f4ed !important;\n}\n:host :is(input,select,textarea):focus-visible {\n  outline: 2px solid #fff0a8 !important;\n  outline-offset: 2px;\n}\n\n:host button[type=\"submit\"] {\n  min-height: 44px !important;\n  width: 100% !important;\n  border: 1px solid #fff0a8 !important;\n  border-radius: 0 !important;\n  background: linear-gradient(105deg,#765015 0%,#c6a15b 24%,#fff0a8 48%,#b98228 70%,#c6a15b 100%) !important;\n  background-size: 260% auto !important;\n  box-shadow: inset 0 0 0 2px rgba(79,50,8,.45),0 0 18px rgba(198,161,91,.16) !important;\n  color: #080705 !important;\n  font-family: \"Courier New\",Courier,monospace !important;\n  font-size: 11px !important;\n  font-weight: 900 !important;\n  letter-spacing: .13em !important;\n  text-transform: uppercase !important;\n  animation: hno-form-shine 6s linear infinite;\n}\n:host button[type=\"submit\"]:hover {\n  filter: brightness(1.08);\n}\n:host button:focus-visible {\n  outline: 2px solid #fff0a8 !important;\n  outline-offset: 3px;\n}\n:host a {\n  color: #c6a15b !important;\n}\n@keyframes hno-form-shine {\n  from { background-position: 180% center; }\n  to { background-position: -80% center; }\n}\n@media(prefers-reduced-motion: reduce) {\n  :host :is(h1,h2,h3,button[type=\"submit\"]) {\n    animation: none !important;\n    background-position: center !important;\n  }\n}\n\n:host {\n  --forms-background-color: #050505 !important;\n  --forms-text-color: #f7f4ed !important;\n  --forms-links-color: #c6a15b !important;\n  --forms-button-background-color: #c6a15b !important;\n  --forms-button-label-color: #080705 !important;\n}\n:host :is(input,select,textarea)[aria-invalid=\"true\"] {\n  border-color: #ffb4b4 !important;\n}\n\n:host {\n  --body-text-color: #f7f4ed !important;\n  --heading-text-color: #c6a15b !important;\n  --link-text-color: #c6a15b !important;\n  --form-error-color: #ffb4b4 !important;\n  --form-text-color: #f7f4ed !important;\n  --form-placeholder-color: rgba(247,244,237,.65) !important;\n  --form-background-color: #050505 !important;\n  --container-background-color: transparent !important;\n  --container-shadow: none !important;\n  --container-border-radius: 0px !important;\n  --form-field-border-radius: 0px !important;\n  --form-field-border: 0 0 0 1px rgba(198,161,91,.68) !important;\n  --form-field-border-focused: 0 0 0 2px #fff0a8 !important;\n  --button-text-color: #080705 !important;\n  --button-background-color: #c6a15b !important;\n  --button-border-radius: 0px !important;\n  --forms-padding-top: 0px !important;\n  --forms-padding-right: 2px !important;\n  --forms-padding-bottom: 0px !important;\n  --forms-padding-left: 2px !important;\n  --inline-container-max-width: 560px !important;\n  --inline-form-alignment: center !important;\n}\n";
          root.appendChild(style);
        };
        this.formObserver = new MutationObserver(this.applyFormStyle);
        this.formObserver.observe(this, { childList: true, subtree: true });
        // Shadow attachment itself isn't observable from the light DOM.
        this.formTimer = setInterval(this.applyFormStyle, 1000);
        this.applyFormStyle();
      }
      disconnectedCallback() {
        if (this.formObserver) this.formObserver.disconnect();
        clearInterval(this.formTimer);
      }
    });
  }

  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
